module.exports = {

    data() {
        return {
            paginator: {
                current_page: 1,
                per_page: 15,
                next_page_url: null,
                prev_page_url: null,
                total: 0,
                data: [],
            },
            hitsPerPage: 15,
            currentPage: 1,
            onSearchMethod: 'resetPage',
        }
    },

    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.paginator.current_page = urlParams.get('page')
    },

    methods: {
        resetPage() {
            this.paginator.current_page = 1;
            this.requestPaginate();
        },

        movePageTo(page) {
            this.paginator.current_page = page;
            this.requestPaginate(page)
        },
    },
}
